module.exports = __webpack_public_path__ + "img/podakun-shy.ea0868f5.svg";